import type { PopoverStylesType } from '@material-tailwind/react';

const styles: PopoverStylesType = {
  defaultProps: {
    placement: 'bottom-end',
    offset: undefined,
  },
  styles: {
    base: {
      spacing: 'p-0',
      border: 'border border-blue-100 rounded-xl',
    },
  },
};

export default styles;
